export default __webpack_public_path__ + "static/media/img_muslinTwoEarsBib_rg.1facc803.jpg";